import React from 'react';

import { Color } from 'store/entity/types';
import { A, ButtonChild, ButtonEle, ButtonWrapper, Spinner } from './style';

const preventClick = (e: React.MouseEvent) => {
  e.preventDefault();
};

type ButtonAndAnchorAttributes = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  React.ButtonHTMLAttributes<HTMLButtonElement>;

export interface IButtonProps extends ButtonAndAnchorAttributes {
  children: React.ReactNode | string;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  href?: string;
  loading?: boolean;
  color?: Color;
  size?: 'large' | 'medium' | 'small';
  type?: 'button' | 'reset' | 'submit';
  style?: React.CSSProperties;
}

const Button: React.FC<IButtonProps> = React.forwardRef<
  ButtonAndAnchorAttributes,
  IButtonProps
>(
  (
    {
      children,
      size = 'medium',
      color = 'primary',
      type = 'button',
      href,
      loading,
      onClick,
      disabled,
      ...props
    },
    ref
  ) => {
    return href ? (
      <A
        href={href}
        color={color}
        onClick={loading || disabled ? preventClick : onClick}
        ref={ref as any}
        size={size}
        type={type}
        {...props}
      >
        {loading && (
          <ButtonWrapper>
            <Spinner color={color} viewBox="0 0 128 128">
              <path
                className="path"
                d="M75.4 126.6a11.4 11.4 0 0 1-2.1-22.6 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.3 4.9h0a63.8 63.8 0 0 1-47.8 48.1v0a11.4 11.4 0 0 1-2.9z"
              />
            </Spinner>
          </ButtonWrapper>
        )}
        <ButtonChild loading={loading}>{children}</ButtonChild>
      </A>
    ) : (
      <ButtonEle
        color={color}
        onClick={loading ? preventClick : onClick}
        disabled={disabled}
        ref={ref as any}
        size={size}
        type={type}
        {...props}
      >
        {loading && (
          <ButtonWrapper>
            <Spinner color={color} viewBox="0 0 128 128">
              <path
                className="path"
                d="M75.4 126.6a11.4 11.4 0 0 1-2.1-22.6 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.3 4.9h0a63.8 63.8 0 0 1-47.8 48.1v0a11.4 11.4 0 0 1-2.9z"
              />
            </Spinner>
          </ButtonWrapper>
        )}
        <ButtonChild loading={loading}>{children}</ButtonChild>
      </ButtonEle>
    );
  }
);

export default React.memo(Button);
